/**
 * @generated SignedSource<<e8b24ad5af72bbbc945b3d68003c58f1>>
 * @relayHash badd6c8f9bae39bb72eddc80aed66301
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f17434c20ee36a43a52bb8f9f002b6dc4f4d6eadb99130b8df0b09209f8160a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessApprovalsQuery } from './src_jiraBusinessApprovalsQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessApprovalsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7f17434c20ee36a43a52bb8f9f002b6dc4f4d6eadb99130b8df0b09209f8160a",
    "metadata": {},
    "name": "src_jiraBusinessApprovalsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
